import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing,
  zindex
} from '../../../theme';

export const StyledOfferBottomBar = styled.div<{
  className?: string;
}>`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zindex('bottomBar')};
  background-color: ${color('midnight_900')};
  color: ${color('text_default_inverse')};
  transform: translateY(100%);
  animation: ShowBar 0.5s 4s forwards;
  transition: opacity 0.2s;
  margin-top: -3.5rem;
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};

  @keyframes ShowBar {
    to {
      transform: translateY(0);
    }
  }

  &.is-scroll {
    animation-delay: 1.5s;
  }

  &.is-detached {
    opacity: 0;
    pointer-events: none;
  }
`;

export const StyledOfferBottomBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: ${container('xlMax')};
  padding-left: ${spacing('sm')};
  padding-right: ${spacing('sm')};
  margin: auto;
  overflow: hidden;
`;

export const StyledOfferBottomBarNavTrigger = styled.button`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding: 0;
  border: 0;
  color: ${color('midnight_500')};
  font-size: ${fontSize('xl')};
  margin-right: ${spacing('md')};

  svg {
    width: 1.25rem !important;
    height: 1.25rem;
  }

  span {
    font-size: ${fontSize('xs')};
    text-transform: uppercase;
    font-weight: ${fontWeight('black')};
  }

  @media (min-width: ${screen('lg')}) {
    display: none;
  }
`;

export const StyledOfferBottomBarLogo = styled.img`
  flex-shrink: 0;
  display: block;
  margin-right: ${spacing('md')};
  max-height: 2rem;
  object-fit: contain;

  @media (max-width: ${screen('mdMax')}) {
    max-width: 8rem;
    margin-right: 0;

    .is-offer-closed & {
      display: none;
    }
  }

  @media (max-width: 399px) {
    max-width: 5.5rem;
  }

  @media (max-width: 359px) {
    display: none;
  }
`;

export const StyledOfferBottomBarPositionLocation = styled.div`
  margin-right: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (max-width: ${screen('lgMax')}) {
    display: none;
  }
`;

export const StyledOfferBottomBarPosition = styled.span`
  font-family: ${fontFamily('serif')};
  font-weight: ${fontWeight('bold')};
`;

export const StyledOfferBottomBarLocation = styled.span`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('sm')};
  color: ${color('text_subtle_inverse')};
`;

export const StyledOfferBottomBarSalaryGroup = styled.div`
  flex-shrink: 0;
  display: flex;

  @media (max-width: ${screen('mdMax')}) {
    display: none;
  }
`;

export const StyledOfferBottomBarSalary = styled.div`
  margin-right: ${spacing('md')};
  display: flex;
  flex-direction: column;
`;

export const StyledOfferBottomBarSalaryTitle = styled.span`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('xs')};
  color: ${color('text_subtle_inverse')};
  text-transform: uppercase;
`;

export const StyledOfferBottomBarSalaryValue = styled.span`
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('sm')};

  span {
    font-weight: ${fontWeight('medium')};
    color: ${color('text_subtle_inverse')};

    &.extra {
      color: ${color('text_default_inverse')};
    }
  }
`;

export const StyledOfferBottomBarActions = styled.div`
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;

  > * {
    margin-left: ${spacing('sm')};
  }

  .share-button {
    @media (max-width: ${screen('lgMax')}) {
      svg {
        margin-right: 0;
        width: ${spacing('lg')} !important;
      }
      span {
        display: none;
      }
    }
  }

  .interested-button {
    @media (max-width: ${screen('md')}) {
      padding: ${spacing('sm')};
    }
  }
`;

export const StyledOfferBottomBarPageNav = styled.div`
  position: absolute;
  bottom: 3.5rem;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: ${color('midnight_900')};
  color: ${color('text_default_inverse')};
  transition: height 0.3s;

  &:not(.is-active) {
    height: 0 !important;
  }

  &.is-active {
    overflow: auto;

    @media (min-width: ${screen('lg')}) {
      display: none;
    }
  }
`;

export const StyledOfferBottomBarUserApplied = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};

  svg {
    color: ${color('positive_500')};
    width: ${spacing('md')} !important;
    height: ${spacing('md')};
  }
`;
